<div class="select-multiple-component">
  <label class="select-label" *ngIf="label!=''">{{label}}</label>
  <div class="select-multiple">
    <ul id="multiple" #listContainer>
      <li *ngFor="let opt of options; let i = index" [ngClass]="{'selected-li': opt.selected, 'disabled-li': opt.disabled }">
        <label class="checklabel"><em>{{opt.title}}</em>
          <input type="checkbox"
          [name]="'option'+i"
          [(ngModel)]="opt.selected"
          value="{{opt.value}}"
          (change)="onChange(opt)"
          [disabled]="opt.disabled"
          />
          <span *ngIf="!opt.disabled" class="checkmark"></span>
        </label>
      </li>
    </ul>
  </div>
</div>
